export default __webpack_public_path__ + "static/media/FurJadenHikingCamping.82cbe5b0.jpg";